<script setup lang="ts">
import { setErrors, clearErrors } from '@formkit/core'

const emit = defineEmits(['submit'])
interface Submit {
  newPassword: string,
  newPasswordConfirm: string
}
const submit = async (data: Submit) => {
  clearErrors('recovery2-form')
  try {
    await useFetch('/store-api/account/recovery-password-confirm', {
      method: 'POST',
      body: {...data, hash: useRoute().query.hash}
    })
    emit('submit', true)
  } catch (e) {
    setErrors(
      'recovery2-form',
      JSON.stringify(e)
    )
  }
}
</script>

<template>
  <FormKit
    type="form"
    id="recovery2-form"
    :actions="false" 
    :incomplete-message="false"
    @submit="submit"
  >
    <FormKit
      type="password"
      outer-class="mb-[10px]"
      name="newPassword"
      label="Nowe hasło*"
      placeholder="Nowe hasło*"
      validation="required"
      validation-visibility="blur"
      :validation-messages="{
        required: 'Pole hasło nie może być puste.'
      }"
    />
    <FormKit
      type="password"
      outer-class="mb-[10px]"
      name="newPasswordConfirm"
      label="Powtórz nowe hasło*"
      placeholder="Powtórz nowe hasło*"
      validation="required"
      validation-visibility="blur"
      :validation-messages="{
        required: 'Pole hasło nie może być puste.'
      }"
    />
    <div class="text-gray-500 text-12">
      * Pole wymagane
    </div>
    <FormKit
      type="submit"
      input-class="btn btn-action btn-lg mb-[10px]"
    >
      <span class="text-16">Zmień hasło</span>
      <i class="icon-arrow-button text-[10px]" />
    </FormKit>
  </FormKit>
</template>
